import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment';

import { OrderPlanningCustomerPreferenceResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class OrderPlanningService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.API_BASE_URL}/service/orderplanning/secure/`;

  getCustomerPreference(year: number): Observable<OrderPlanningCustomerPreferenceResponse> {
    return this.http.get<OrderPlanningCustomerPreferenceResponse>(`${this.baseUrl}customerpreference/all/${year}`);
  }
}
